import { PriceType, Project } from '@nexxt/common/types';
import * as React from 'react';
import { ILocation } from '../../../../interface/common.interface';
import Modal, {
    ModalBody,
    ModalHeader,
    ModalTitle
} from '../../../common/modal';
import CustomPrice from './CustomPrice';
import IncidenceRate from './CustomPrice/IncidenceRate';
import RequestQuote from './CustomPrice/RequestQuote';
import PriceDetail from './PriceDetail';

interface PriceModalProps {
    currentProject: Project;
    type: any;
    contentOnly: boolean;
    devMode: boolean;
    totalQuestionCount: number;
    onClose: () => void;
    changePath: (path: string | ILocation) => void;
    getPrice: (data: any) => Promise<any>;
    setProject: (project: Project) => Promise<any>;
    forceOpenCheckout?: () => void;
    launchSandbox?: () => void;
}

interface PriceModalState {
    toggleIncidenceRateModal: boolean;
}

class PriceModal extends React.Component<PriceModalProps, PriceModalState> {
    state = { toggleIncidenceRateModal: false };

    setToggleIncidenceRateModal = () => {
        this.setState({
            toggleIncidenceRateModal: !this.state.toggleIncidenceRateModal
        });
    };
    updatePrice = async (data) => {
        await this.props.getPrice({
            ...data,
            projectID: this.props.currentProject.id
        });

        if (data?.incidenceRate) {
            await this.props.setProject({
                ...this.props.currentProject,
                incidenceRate: data.incidenceRate
            });
        }
    };
    renderBody = (type) => {
        const { devMode, contentOnly, currentProject, onClose, changePath } =
            this.props;
        if (this.state.toggleIncidenceRateModal) {
            return (
                <CustomPrice
                    onClose={onClose}
                    updatePrice={this.updatePrice}
                    toggleIncidenceRateModal={
                        this.state.toggleIncidenceRateModal
                    }
                    incidenceRate={this.props.currentProject.incidenceRate}
                />
            );
        }

        if (contentOnly && type.PRICE_MODE === PriceType.NOT_FEASIBLE) {
            return (
                <PriceDetail
                    currentProject={currentProject}
                    onClose={onClose}
                    changePath={changePath}
                    isPriceModal={true}
                    type={type}
                    devMode={devMode}
                    setToggleIncidenceRateModal={
                        this.setToggleIncidenceRateModal
                    }
                    launchSandbox={this.props.launchSandbox}
                    totalQuestionCount={this.props.totalQuestionCount}
                    //launch sandbox
                />
            );
        }

        switch (type?.PRICE_MODE) {
            case PriceType.NOT_FEASIBLE:
                return (
                    <CustomPrice
                        notFeasible={true}
                        onClose={onClose}
                        updatePrice={this.updatePrice}
                        project={this.props.currentProject}
                        incidenceRate={this.props.currentProject?.incidenceRate}
                        forceOpenCheckout={this.props.forceOpenCheckout}
                    />
                );
            case PriceType.CUSTOM:
                return (
                    <CustomPrice
                        onClose={onClose}
                        updatePrice={this.updatePrice}
                        incidenceRate={this.props.currentProject?.incidenceRate}
                    />
                );
            case PriceType.REQUEST_QUOTE:
                return <RequestQuote onClose={onClose} isRequested={true} />;
            case PriceType.INCIDENCE:
                return (
                    <IncidenceRate
                        onClose={onClose}
                        updatePrice={this.updatePrice}
                        isRequested={true}
                    />
                );
            default:
                return (
                    <PriceDetail
                        currentProject={currentProject}
                        onClose={onClose}
                        changePath={changePath}
                        isPriceModal={true}
                        type={type}
                        devMode={devMode}
                        setToggleIncidenceRateModal={
                            this.setToggleIncidenceRateModal
                        }
                        launchSandbox={this.props.launchSandbox}
                        totalQuestionCount={this.props.totalQuestionCount}
                        //launch sandbox
                    />
                );
        }
    };
    render() {
        const { type, contentOnly, onClose } = this.props;
        return contentOnly ? (
            this.renderBody(type)
        ) : (
            <Modal isOpen={true}>
                <ModalHeader onClose={onClose}></ModalHeader>
                <ModalBody className="price--modal">
                    {this.renderBody(type)}
                </ModalBody>
            </Modal>
        );
    }
}

export default PriceModal;
